import {LocalDateTime} from "js-joda";
import {ICONS_URL} from "../../../const";
import {Address} from "../../address/model/Address";
import {ActionTypes} from "../../action_status/model/ActionType";
import {ActionStatus} from "../../action_status/model/ActionStatus";


export interface OpportunityActionsGroup {
    key: GroupedOpportunityKey,
    value: OpportunityAction[]
}

export class GroupedOpportunityKey {
    customerId: number;
    calculatorId: number;


    constructor(customerId: number, calculatorId: number) {
        this.customerId = customerId;
        this.calculatorId = calculatorId;
    }

    equals(other: GroupedOpportunityKey): boolean {
        return other.customerId === this.customerId && other.calculatorId === this.calculatorId;
    }
}

export interface OpportunityAction {
    id?: number;
    actionType: ActionTypes;
    status: ActionStatus;
    customerId: number;
    calculatorId: number;
    calculationExecutionLogId: number;
    executionStarted?: LocalDateTime;
    executionFinished?: LocalDateTime;
    iconUrl?: string;
    iconColor?: string;
    addressTo?: Address;
    addressFrom?: Address;
}

export interface GuiOpportunityAction {
    actionType: ActionTypes;
    description: string;
    executionStarted: LocalDateTime;
    executionFinished: LocalDateTime;
    status: ActionStatus;
}

export interface OpportunityActionGroup {
    actionType: ActionTypes;
    count: number;
    opportunityActions: OpportunityAction[];
}

export interface OpportunityActionImpl {
    getIconUrl: () => string;
    getIconColor: () => string;
}

export const OpportunityActionBuilder = (action: OpportunityAction): OpportunityActionImpl => {
    switch (action.actionType) {
        case ActionTypes.EMAIL:
            return new OpportunityEmailAction(action);
    }
};


export class OpportunityEmailAction implements OpportunityActionImpl {
    action: OpportunityAction;

    constructor(action: OpportunityAction) {
        this.action = action;
    }

    getIconUrl = () => {
        return ICONS_URL + 'email.svg'
    };

    getIconColor = () => {
        return "#ff5722";
    }

}